// extracted by mini-css-extract-plugin
module.exports = {"floatingActionButton":"FloatingActionButton_floatingActionButton__pPJ60"};